import React, { Component } from "react";
import Image from '../global/Image';

export default class PageBrand extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--' + block.bg_color}>
			    
			    	<div className="c-page__block__inner c-page__block__inner--small-margins">
			    	
			    		<div className="c-brand">
			    		
			    			<div className="c-brand__top">
			    			
				    			{block.logo_height && block.logo_code &&
					    			<div className="c-brand__logo" style={{height:block.logo_height + 'px'}} dangerouslySetInnerHTML={{__html:block.logo_code}}></div>
					    		}
					    			  		
					    		{block.text &&
						    		<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:block.text}}></div>
					    		}
				    		
					    		{block.website_text && block.website &&
						    		<div className="c-buttons">
							    		<a href={block.website} className="c-button" target="_blank" dangerouslySetInnerHTML={{__html:block.website_text}}></a>
						    		</div>
					    		}
				    		
				    		</div>
				    		
				    		{block.left_src && block.right_src &&
					    		
					    		<div className="c-brand__images">
				    		
					    			<div className="c-brand__images__image c-brand__images__image--left">
										
										{block.left_src &&
					    					<Image width={block.left_width} height={block.left_height} srcset={block.left_srcset} src={block.left_src} />
					    				}
					    				
					    			</div>
					    			
					    			<div className="c-brand__images__image c-brand__images__image--right">
					    				
					    				{block.right_src &&
					    					<Image width={block.right_width} height={block.right_height} srcset={block.right_srcset} src={block.right_src} />
					    				}
					    			
					    			</div>
					    			
					    		</div>
					    		
					    	}
				    		
				    	</div>
			    		
			    	</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
